import React, { createContext, useContext, useState, useEffect } from 'react';

const PageActionContext = createContext();

export function PageActionProvider({ children }) {
  const [actions, setActions] = useState(null);

  // Helper to allow pages to set actions cleanly
  // usage in page: usePageActions(<button>Save</button>)
  const setPageActions = (component) => {
    setActions(component);
  };

  return (
    <PageActionContext.Provider value={{ actions, setPageActions }}>
      {children}
    </PageActionContext.Provider>
  );
}

export function usePageAction(component) {
  const context = useContext(PageActionContext);
  if (!context) {
    throw new Error('usePageAction must be used within a PageActionProvider');
  }

  const { setPageActions } = context;

  // Update actions when component mounts or changes
  useEffect(() => {
    setPageActions(component);
    
    // Cleanup when unmounting
    return () => setPageActions(null);
  }, [component]); // Be careful with dependencies here, might want to use refs or memo if component is unstable
  
  return context;
}

export function usePageActionContext() {
   return useContext(PageActionContext);
}
